import React from 'react';
import { Box, Paper, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from './UIKit/Button';

const BannerWrapper = styled(Paper)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  padding: theme.spacing(3),
  borderRadius: 0,
  zIndex: 9999,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)',
}));

const CookieBanner = ({ onAccept }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handlePrivacyPolicyClick = () => {
    navigate('/privacy-policy');
  };

  return (
    <BannerWrapper elevation={8}>
      <Box maxWidth="lg" margin="0 auto">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
        >
          <Box flex={1}>
            <Typography variant="body1" gutterBottom>
              {t('cookieBanner.title')}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {t('cookieBanner.description')}
            </Typography>
          </Box>
          <Stack direction="row" spacing={2} sx={{ minWidth: { sm: 'auto' } }}>
            <Button
              variant="outlined"
              onClick={handlePrivacyPolicyClick}
              sx={{ minWidth: 120 }}
            >
              {t('cookieBanner.privacyPolicy')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={onAccept}
              sx={{ minWidth: 100 }}
            >
              {t('cookieBanner.accept')}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </BannerWrapper>
  );
};

export default CookieBanner;
